var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Preview corpo email:")]),_c('iframe',{attrs:{"id":"preview","sandbox":"allow-popups","frameborder":"0","width":"100%","height":"600","srcdoc":_vm.html}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }